/*
 * Cart drawer "You may also like": shows a few products from the same
 * category collections as the products in the cart (one category after the
 * other, so every category in the cart is represented), falling back to
 * Shopify "related" recommendations for products without a category.
 * Refreshes whenever the mini cart content changes.
 */
(function () {
  var wrapperSelector = '.drawer-crossell';
  var sliderSelector = '.drawer-crossell-product';
  var cartContentSelector = '.js-mini-cart-content';
  var maxItems = 4;
  var maxSeeds = 4;
  var lastKey = null;
  var pending = null;
  var itemsBySeed = {};

  var sliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    dots: false,
    arrows: true,
    infinite: false
  };

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function setSlides($slider, html) {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    $slider.html(html);
    if (html && typeof $slider.slick === 'function') {
      $slider.slick(sliderOptions);
    }
  }

  function fetchItems(url) {
    return fetch(url)
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.drawer-crossell__item'));
      })
      .catch(function () { return []; });
  }

  // Same-category products for one cart item; Shopify "related" if it has no category.
  function itemsForSeed(seed) {
    if (itemsBySeed[seed.product_id]) {
      return Promise.resolve(itemsBySeed[seed.product_id]);
    }
    var categoryUrl = seed.url.split('?')[0] + '?section_id=cart-recommendations';
    var relatedUrl = root() + 'recommendations/products?section_id=cart-recommendations' +
      '&product_id=' + seed.product_id + '&limit=10&intent=related';
    return fetchItems(categoryUrl)
      .then(function (items) { return items.length ? items : fetchItems(relatedUrl); })
      .then(function (items) {
        itemsBySeed[seed.product_id] = items;
        return items;
      });
  }

  function render(cart) {
    var $wrapper = jQuery(wrapperSelector);
    var $slider = jQuery(sliderSelector);
    if (!$wrapper.length || !$slider.length) return;

    // cart.items is newest-first; one seed per distinct product.
    var seeds = [];
    var inCart = [];
    cart.items.forEach(function (item) {
      var id = String(item.product_id);
      if (inCart.indexOf(id) !== -1) return;
      inCart.push(id);
      if (seeds.length < maxSeeds) seeds.push(item);
    });

    var key = inCart.join(',');
    if (key === lastKey) return;
    lastKey = key;

    if (!seeds.length) {
      setSlides($slider, '');
      $wrapper.addClass('drawer-crossell--empty');
      return;
    }

    Promise.all(seeds.map(itemsForSeed)).catch(function () {
      lastKey = null;
      return [];
    }).then(function (lists) {
      if (key !== lastKey) return;

      // Take products from each cart item's category in turn.
      var picked = [];
      var html = '';
      var index = 0;
      var remaining = true;
      while (picked.length < maxItems && remaining) {
        remaining = false;
        lists.forEach(function (list) {
          if (picked.length >= maxItems || index >= list.length) return;
          remaining = true;
          var item = list[index];
          var id = String(item.getAttribute('data-product-id'));
          if (inCart.indexOf(id) !== -1 || picked.indexOf(id) !== -1) return;
          picked.push(id);
          html += item.outerHTML;
        });
        index++;
      }

      setSlides($slider, html);
      $wrapper.toggleClass('drawer-crossell--empty', picked.length === 0);
    });
  }

  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch(root() + 'cart.js')
        .then(function (response) { return response.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  function init() {
    if (!window.jQuery || !document.querySelector(sliderSelector)) return;
    var observer = new MutationObserver(refresh);
    document.querySelectorAll(cartContentSelector).forEach(function (cartContent) {
      observer.observe(cartContent, { childList: true, subtree: true });
    });
    // Also catch cart changes made through jQuery AJAX (add, change, remove).
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (settings && /\/cart\/(add|change|update|clear)/.test(settings.url || '')) refresh();
    });
    refresh();
  }

  if (window.jQuery) {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
